// src/lib/i18n/date/relative.ts
import { formatDistanceToNow as distanceGregorian } from "date-fns";
import { ar, enUS } from "date-fns/locale";
import { formatDistanceToNow as distanceJalali } from "date-fns-jalali";
import { faIR } from "date-fns-jalali/locale";
import type { Locale } from "@/lib/i18n";
import { shapeDigits } from "./digits";
import { type DateInput, toDate } from "./to-date";

/** "3 days ago" / "۳ روز پیش" / "منذ ٣ أيام" — relative to now, locale-shaped. */
export function formatRelative(input: DateInput, locale: Locale): string {
  const date = toDate(input);
  if (locale === "fa") {
    // date-fns-jalali renders past distances with a trailing «قبل»; design uses
    // «پیش». Anchor to the suffix so it can never match mid-word (e.g. مستقبل).
    const out = distanceJalali(date, { addSuffix: true, locale: faIR });
    return shapeDigits(out.replace(/ قبل$/, " پیش"), "fa");
  }
  const out = distanceGregorian(date, {
    addSuffix: true,
    locale: locale === "ar" ? ar : enUS,
  });
  return shapeDigits(out, locale);
}
